<template><section><h2>多类别气泡图</h2>
<block-demo tip="" source="const { Chart, Axis, Scatter, Legend, Tooltip } = qcharts
const data = [
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Argentina&#39;,
    LifeExpectancy: 75.32,
    GDP: 12779.37964,
    Population: 40301927
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Brazil&#39;,
    LifeExpectancy: 72.39,
    GDP: 9065.800825,
    Population: 190010647
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Canada&#39;,
    LifeExpectancy: 80.653,
    GDP: 36319.23501,
    Population: 33390141
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Chile&#39;,
    LifeExpectancy: 78.553,
    GDP: 13171.63885,
    Population: 16284741
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Colombia&#39;,
    LifeExpectancy: 72.889,
    GDP: 7006.580419,
    Population: 44227550
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Costa Rica&#39;,
    LifeExpectancy: 78.782,
    GDP: 9645.06142,
    Population: 4133884
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Cuba&#39;,
    LifeExpectancy: 78.273,
    GDP: 8948.102923,
    Population: 11416987
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Dominican Republic&#39;,
    LifeExpectancy: 72.235,
    GDP: 6025.374752,
    Population: 9319622
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Ecuador&#39;,
    LifeExpectancy: 74.994,
    GDP: 6873.262326,
    Population: 13755680
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;El Salvador&#39;,
    LifeExpectancy: 71.878,
    GDP: 5728.353514,
    Population: 6939688
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Guatemala&#39;,
    LifeExpectancy: 70.259,
    GDP: 5186.050003,
    Population: 12572928
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Honduras&#39;,
    LifeExpectancy: 70.198,
    GDP: 3548.330846,
    Population: 7483763
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Jamaica&#39;,
    LifeExpectancy: 72.567,
    GDP: 7320.880262,
    Population: 2780132
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Mexico&#39;,
    LifeExpectancy: 76.195,
    GDP: 11977.57496,
    Population: 108700891
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Nicaragua&#39;,
    LifeExpectancy: 72.899,
    GDP: 2749.320965,
    Population: 5675356
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Panama&#39;,
    LifeExpectancy: 75.537,
    GDP: 9809.185636,
    Population: 3242173
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Paraguay&#39;,
    LifeExpectancy: 71.752,
    GDP: 4172.838464,
    Population: 6667147
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Peru&#39;,
    LifeExpectancy: 71.421,
    GDP: 7408.905561,
    Population: 28674757
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Puerto Rico&#39;,
    LifeExpectancy: 78.746,
    GDP: 19328.70901,
    Population: 3942491
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Trinidad and Tobago&#39;,
    LifeExpectancy: 69.819,
    GDP: 18008.50924,
    Population: 1056608
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;United States&#39;,
    LifeExpectancy: 78.242,
    GDP: 42951.65309,
    Population: 301139947
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Uruguay&#39;,
    LifeExpectancy: 76.384,
    GDP: 10611.46299,
    Population: 3447496
  },
  {
    continent: &#39;Americas&#39;,
    Country: &#39;Venezuela&#39;,
    LifeExpectancy: 73.747,
    GDP: 11415.80569,
    Population: 26084662
  },
  {
    continent: &#39;Asia&#39;,
    Country: &#39;China&#39;,
    LifeExpectancy: 72.961,
    GDP: 4959.114854,
    Population: 1318683096
  },
  {
    continent: &#39;Asia&#39;,
    Country: &#39;Hong Kong, China&#39;,
    LifeExpectancy: 82.208,
    GDP: 39724.97867,
    Population: 6980412
  },
  {
    continent: &#39;Asia&#39;,
    Country: &#39;Japan&#39;,
    LifeExpectancy: 82.603,
    GDP: 31656.06806,
    Population: 127467972
  },
  {
    continent: &#39;Asia&#39;,
    Country: &#39;Korea, Dem. Rep.&#39;,
    LifeExpectancy: 67.297,
    GDP: 1593.06548,
    Population: 23301725
  },
  {
    continent: &#39;Asia&#39;,
    Country: &#39;Korea, Rep.&#39;,
    LifeExpectancy: 78.623,
    GDP: 23348.13973,
    Population: 49044790
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Albania&#39;,
    LifeExpectancy: 76.423,
    GDP: 5937.029526,
    Population: 3600523
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Austria&#39;,
    LifeExpectancy: 79.829,
    GDP: 36126.4927,
    Population: 8199783
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Belgium&#39;,
    LifeExpectancy: 79.441,
    GDP: 33692.60508,
    Population: 10392226
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Bosnia and Herzegovina&#39;,
    LifeExpectancy: 74.852,
    GDP: 7446.298803,
    Population: 4552198
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Bulgaria&#39;,
    LifeExpectancy: 73.005,
    GDP: 10680.79282,
    Population: 7322858
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Croatia&#39;,
    LifeExpectancy: 75.748,
    GDP: 14619.22272,
    Population: 4493312
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Czech Republic&#39;,
    LifeExpectancy: 76.486,
    GDP: 22833.30851,
    Population: 10228744
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Denmark&#39;,
    LifeExpectancy: 78.332,
    GDP: 35278.41874,
    Population: 5468120
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Finland&#39;,
    LifeExpectancy: 79.313,
    GDP: 33207.0844,
    Population: 5238460
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;France&#39;,
    LifeExpectancy: 80.657,
    GDP: 30470.0167,
    Population: 61083916
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Germany&#39;,
    LifeExpectancy: 79.406,
    GDP: 32170.37442,
    Population: 82400996
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Greece&#39;,
    LifeExpectancy: 79.483,
    GDP: 27538.41188,
    Population: 10706290
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Hungary&#39;,
    LifeExpectancy: 73.338,
    GDP: 18008.94444,
    Population: 9956108
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Iceland&#39;,
    LifeExpectancy: 81.757,
    GDP: 36180.78919,
    Population: 301931
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Ireland&#39;,
    LifeExpectancy: 78.885,
    GDP: 40675.99635,
    Population: 4109086
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Italy&#39;,
    LifeExpectancy: 80.546,
    GDP: 28569.7197,
    Population: 58147733
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Montenegro&#39;,
    LifeExpectancy: 74.543,
    GDP: 9253.896111,
    Population: 684736
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Netherlands&#39;,
    LifeExpectancy: 79.762,
    GDP: 36797.93332,
    Population: 16570613
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Norway&#39;,
    LifeExpectancy: 80.196,
    GDP: 49357.19017,
    Population: 4627926
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Poland&#39;,
    LifeExpectancy: 75.563,
    GDP: 15389.92468,
    Population: 38518241
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Portugal&#39;,
    LifeExpectancy: 78.098,
    GDP: 20509.64777,
    Population: 10642836
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Romania&#39;,
    LifeExpectancy: 72.476,
    GDP: 10808.47561,
    Population: 22276056
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Serbia&#39;,
    LifeExpectancy: 74.002,
    GDP: 9786.534714,
    Population: 10150265
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Slovak Republic&#39;,
    LifeExpectancy: 74.663,
    GDP: 18678.31435,
    Population: 5447502
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Slovenia&#39;,
    LifeExpectancy: 77.926,
    GDP: 25768.25759,
    Population: 2009245
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Spain&#39;,
    LifeExpectancy: 80.941,
    GDP: 28821.0637,
    Population: 40448191
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Sweden&#39;,
    LifeExpectancy: 80.884,
    GDP: 33859.74835,
    Population: 9031088
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Switzerland&#39;,
    LifeExpectancy: 81.701,
    GDP: 37506.41907,
    Population: 7554661
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;Turkey&#39;,
    LifeExpectancy: 71.777,
    GDP: 8458.276384,
    Population: 71158647
  },
  {
    continent: &#39;Europe&#39;,
    Country: &#39;United Kingdom&#39;,
    LifeExpectancy: 79.425,
    GDP: 33203.26128,
    Population: 60776238
  },
  {
    continent: &#39;Oceania&#39;,
    Country: &#39;Australia&#39;,
    LifeExpectancy: 81.235,
    GDP: 34435.36744,
    Population: 20434176
  },
  {
    continent: &#39;Oceania&#39;,
    Country: &#39;New Zealand&#39;,
    LifeExpectancy: 80.204,
    GDP: 25185.00911,
    Population: 4115771
  }
]
const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;continent&#39;,
  text: &#39;GDP&#39;,
  value: &#39;LifeExpectancy&#39;
})
const scatter = new Scatter({
  areaField: &#39;Population&#39;,
  areaRange: [4, 30]
})

const axisBottom = new Axis()

const axisLeft = new Axis({ orient: &#39;left&#39; })

const legend = new Legend({ align: [&#39;center&#39;, &#39;bottom&#39;] })

chart.append([scatter, axisBottom, axisLeft, legend])

chart.append(
  new Tooltip({
    title: data =&gt; data[0].Country,
    formatter: data =&gt; {
      return ` 人均寿命：${data.LifeExpectancy} GDP：${data.GDP} `
    }
  })
)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> { Chart, Axis, Scatter, Legend, Tooltip } = qcharts
<span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Argentina'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">75.32</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">12779.37964</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">40301927</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Brazil'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.39</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">9065.800825</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">190010647</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Canada'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.653</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">36319.23501</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">33390141</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Chile'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.553</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">13171.63885</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">16284741</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Colombia'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.889</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">7006.580419</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">44227550</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Costa Rica'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.782</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">9645.06142</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4133884</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Cuba'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.273</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">8948.102923</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">11416987</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Dominican Republic'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.235</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">6025.374752</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">9319622</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Ecuador'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">74.994</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">6873.262326</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">13755680</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'El Salvador'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">71.878</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">5728.353514</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">6939688</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Guatemala'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">70.259</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">5186.050003</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">12572928</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Honduras'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">70.198</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">3548.330846</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">7483763</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Jamaica'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.567</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">7320.880262</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">2780132</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Mexico'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">76.195</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">11977.57496</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">108700891</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Nicaragua'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.899</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">2749.320965</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">5675356</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Panama'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">75.537</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">9809.185636</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">3242173</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Paraguay'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">71.752</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">4172.838464</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">6667147</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Peru'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">71.421</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">7408.905561</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">28674757</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Puerto Rico'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.746</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">19328.70901</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">3942491</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Trinidad and Tobago'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">69.819</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">18008.50924</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">1056608</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'United States'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.242</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">42951.65309</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">301139947</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Uruguay'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">76.384</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">10611.46299</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">3447496</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Americas'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Venezuela'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">73.747</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">11415.80569</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">26084662</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Asia'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'China'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.961</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">4959.114854</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">1318683096</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Asia'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Hong Kong, China'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">82.208</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">39724.97867</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">6980412</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Asia'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Japan'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">82.603</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">31656.06806</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">127467972</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Asia'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Korea, Dem. Rep.'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">67.297</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">1593.06548</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">23301725</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Asia'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Korea, Rep.'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.623</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">23348.13973</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">49044790</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Albania'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">76.423</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">5937.029526</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">3600523</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Austria'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.829</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">36126.4927</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">8199783</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Belgium'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.441</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">33692.60508</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">10392226</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Bosnia and Herzegovina'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">74.852</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">7446.298803</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4552198</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Bulgaria'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">73.005</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">10680.79282</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">7322858</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Croatia'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">75.748</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">14619.22272</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4493312</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Czech Republic'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">76.486</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">22833.30851</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">10228744</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Denmark'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.332</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">35278.41874</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">5468120</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Finland'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.313</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">33207.0844</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">5238460</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'France'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.657</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">30470.0167</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">61083916</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Germany'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.406</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">32170.37442</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">82400996</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Greece'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.483</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">27538.41188</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">10706290</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Hungary'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">73.338</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">18008.94444</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">9956108</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Iceland'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">81.757</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">36180.78919</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">301931</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Ireland'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.885</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">40675.99635</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4109086</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Italy'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.546</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">28569.7197</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">58147733</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Montenegro'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">74.543</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">9253.896111</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">684736</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Netherlands'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.762</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">36797.93332</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">16570613</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Norway'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.196</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">49357.19017</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4627926</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Poland'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">75.563</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">15389.92468</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">38518241</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Portugal'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">78.098</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">20509.64777</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">10642836</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Romania'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">72.476</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">10808.47561</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">22276056</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Serbia'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">74.002</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">9786.534714</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">10150265</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Slovak Republic'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">74.663</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">18678.31435</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">5447502</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Slovenia'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">77.926</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">25768.25759</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">2009245</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Spain'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.941</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">28821.0637</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">40448191</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Sweden'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.884</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">33859.74835</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">9031088</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Switzerland'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">81.701</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">37506.41907</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">7554661</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Turkey'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">71.777</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">8458.276384</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">71158647</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Europe'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'United Kingdom'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">79.425</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">33203.26128</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">60776238</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Oceania'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'Australia'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">81.235</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">34435.36744</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">20434176</span>
  },
  {
    <span class="hljs-attr">continent</span>: <span class="hljs-string">'Oceania'</span>,
    <span class="hljs-attr">Country</span>: <span class="hljs-string">'New Zealand'</span>,
    <span class="hljs-attr">LifeExpectancy</span>: <span class="hljs-number">80.204</span>,
    <span class="hljs-attr">GDP</span>: <span class="hljs-number">25185.00911</span>,
    <span class="hljs-attr">Population</span>: <span class="hljs-number">4115771</span>
  }
]
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'continent'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'GDP'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'LifeExpectancy'</span>
})
<span class="hljs-keyword">const</span> scatter = <span class="hljs-keyword">new</span> Scatter({
  <span class="hljs-attr">areaField</span>: <span class="hljs-string">'Population'</span>,
  <span class="hljs-attr">areaRange</span>: [<span class="hljs-number">4</span>, <span class="hljs-number">30</span>]
})

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()

<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'bottom'</span>] })

chart.append([scatter, axisBottom, axisLeft, legend])

chart.append(
  <span class="hljs-keyword">new</span> Tooltip({
    <span class="hljs-attr">title</span>: <span class="hljs-function"><span class="hljs-params">data</span> =&gt;</span> data[<span class="hljs-number">0</span>].Country,
    <span class="hljs-attr">formatter</span>: <span class="hljs-function"><span class="hljs-params">data</span> =&gt;</span> {
      <span class="hljs-keyword">return</span> <span class="hljs-string">` 人均寿命：<span class="hljs-subst">${data.LifeExpectancy}</span> GDP：<span class="hljs-subst">${data.GDP}</span> `</span>
    }
  })
)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>